// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2526f0c2","977":"2ef94a64"}[chunkId] + ".chunk.js";
};